/** Role constants matching backend JWT/user-info */
export const ROLES = {
  USER: 'ROLE_USER',
  ADMIN: 'ROLE_ADMIN'
} as const;

/** Returns true if the user has admin role */
export function isAdmin(roles: string[] | undefined | null): boolean {
  return !!roles?.includes(ROLES.ADMIN);
}
